import { NyukyoshaShomeiViewModel } from "./NyukyoshaShomeiViewModel";
import { NyukyoshaInformationViewModel } from "./NyukyoshaInformationViewModel";
import Enumerable from "linq";
export class NyukyoshaViewModel {
    constructor(data = null) {
        if (!data) {
            return;
        }
        this.model = data;
        this.userCd = data.userCd;
        this.userKb = data.userKb;
        this.nyukyokeiyakuNo = data.nyukyokeiyakuNo;
        this.orgNyukyokeiyakuNo = data.orgNyukyokeiyakuNo;
        this.lifeKainNo = data.lifeKainNo;
        this.taikyoStatus = data.taikyoStatus;
        this.postCode = data.postCode;
        this.adr1 = data.adr1;
        this.adr2 = data.adr2;
        this.bukkenNameWithRoom = data.bukkenNameWithRoom;
        this.addressAll = data.addressAll;
        this.keiyakusha = data.keiyakusha;
        this.nyukyosha = data.nyukyosha;
        this.telephoneNumber = data.telephoneNumber;
        this.email = data.email;
        this.keiyakuYmd = data.keiyakuYmd;
        this.shopName = data.shopName;
        this.isSelfCertificateCheck = data.isSelfCertificateCheck;
        this.showSelfCertificateCheckButton = data.showSelfCertificateCheckButton;
        this.shomeiList = Enumerable.from(data.shomeiList)
            .select(x => new NyukyoshaShomeiViewModel(x))
            .toArray();
        this.informationList = Enumerable.from(data.informationList)
            .select(x => new NyukyoshaInformationViewModel(x))
            .toArray();
        this.updateDate = data.updateDate;
        this.lockDate = data.lockDate;
        this.failuresCount = data.failuresCount;
    }
    model = null;
    userCd = -1;
    userKb = -1;
    nyukyokeiyakuNo = -1;
    orgNyukyokeiyakuNo = -1;
    lifeKainNo = "";
    taikyoStatus = -1;
    postCode = "";
    adr1 = "";
    adr2 = "";
    bukkenNameWithRoom = "";
    addressAll = "";
    keiyakusha = "";
    nyukyosha = "";
    telephoneNumber = "";
    email = "";
    keiyakuYmd = "";
    shopName = "";
    isSelfCertificateCheck = true;
    showSelfCertificateCheckButton = false;
    shomeiList = [];
    informationList = [];
    updateDate = "";
    lockDate = "";
    failuresCount = null;
}
